export default __webpack_public_path__ + "app/images/user/img-cs-big.svg";